class CollectionTabsPanel extends HTMLElement {
  connectedCallback() {
    this._resizeObserver = new ResizeObserver(() => {
      if (!this.hidden) {
        const scrollCarousel = this.querySelector('scroll-carousel');
        if (scrollCarousel) {
          const isScrollable = scrollCarousel.scrollWidth > scrollCarousel.clientWidth;
          scrollCarousel.classList.toggle('is-scrollable', isScrollable);
        }
      }
    });
    this._resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this._resizeObserver?.disconnect();
  }
}

if (!customElements.get('collection-tabs-panel')) {
  customElements.define('collection-tabs-panel', CollectionTabsPanel);
}

/* Custom underline draw-in on viewport entry */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const NS = 'http://www.w3.org/2000/svg';
  let counter = 0;

  const centerlines = {
    '0 0 207 22': {
      d: 'M 4 5 C 60 4 120 5 155 6 C 160 5 163 7 160 10 C 130 12 90 14 63 15 C 100 16 150 17 180 18 L 205 17',
      strokeWidth: 14,
    },
    '0 0 167 32': {
      d: 'M 4 11 C 40 10 80 8 125 7 C 140 6 150 6 158 6 C 145 10 120 14 103 17 C 120 18 145 20 157 21 L 164 20 C 158 23 150 25 136 28',
      strokeWidth: 30,
    },
  };

  const setupDrawAnimation = (el) => {
    const svg = el.querySelector('.custom-underline__svg');
    if (!svg || el.classList.contains('custom-underline--animate-ready')) return;

    const config = centerlines[svg.getAttribute('viewBox')];
    if (!config) return;

    const fillPath = svg.querySelector('path');
    if (!fillPath) return;

    const maskId = `cu-m-${counter++}`;
    const defs = document.createElementNS(NS, 'defs');
    const mask = Object.assign(document.createElementNS(NS, 'mask'), { id: maskId });
    const stroke = document.createElementNS(NS, 'path');

    stroke.setAttribute('d', config.d);
    stroke.setAttribute('stroke', 'white');
    stroke.setAttribute('stroke-width', config.strokeWidth);
    stroke.setAttribute('fill', 'none');
    stroke.setAttribute('stroke-linecap', 'round');
    stroke.setAttribute('stroke-linejoin', 'round');

    mask.appendChild(stroke);
    defs.appendChild(mask);
    svg.insertBefore(defs, svg.firstChild);
    fillPath.setAttribute('mask', `url(#${maskId})`);

    const len = stroke.getTotalLength();
    stroke.style.strokeDasharray = len;
    stroke.style.strokeDashoffset = len;

    el.classList.add('custom-underline--animate-ready');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        stroke.style.transition = 'stroke-dashoffset 1.2s cubic-bezier(0.22, 1, 0.36, 1) 0.3s';
        stroke.style.strokeDashoffset = '0';
      });
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        setupDrawAnimation(entry.target);
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.1 },
  );

  const observeUnderlines = (root) => {
    root.querySelectorAll('.custom-underline').forEach((el) => observer.observe(el));
  };

  observeUnderlines(document);
  document.addEventListener('shopify:section:load', (e) => observeUnderlines(e.target));
})();
